export function getVersionFromBaseUrl(baseUrl) {
    var isLocal = baseUrl.includes('localhost');
    if (isLocal) {
        return;
    }
    var pathFragments = baseUrl.split('/');
    return pathFragments[pathFragments.length - 2];
}
//# sourceMappingURL=sentryUtils.js.map